"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBooleanStringToBoolean = transformBooleanStringToBoolean;
function transformBooleanStringToBoolean(booleanString) {
    if (booleanString === "true") {
        return true;
    }
    if (booleanString === "false") {
        return false;
    }
    return undefined;
}
//# sourceMappingURL=transformBooleanStringToBoolean.js.map